<template>
    <div class="line-charts">
        <v-chart v-if="lineData.length > 0" :ref="chartNmae" class="cv-chart" :options="lineOption" autoresize></v-chart>
        <div v-else class="nodata">
            <img src="../assets/images/no-data.png" alt="">
        </div>
    </div>
</template>

<script>
import PubSub from 'pubsub-js'
export default {
    name: 'lineCharts',
    computed: {},
    props: {
        lineDatas: {
            type: Array,
            default: () => {
                return [{
                    month: '1月',
                    house: 2
                },
                {
                    month: '2月',
                    house: 3
                }]
            }
        },
        chartNmaes: {
            type: String,
            default: () => {
                return 'lineCharts'
            }
        },
    },
    watch: {},
    data() {
        return {
            chartNmae: this.chartNmaes,
            lineData: [],
            lineOption: {
                grid: {
                    top: '2%',
                    left: '2%',
                    right: '4%',
                    bottom: '2%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ffebe0',
                        },
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    axisLabel: {
                        fontSize: 14,
                        color: '#fff',
                    },
                    splitLine: {
                        show: false,
                    },
                },
                yAxis: {
                    type: 'value',
                    splitNumber: 5,
                    axisLine: {
                        lineStyle: {
                            color: '#ffebe0',
                        },
                    },
                    axisLabel: {
                        fontSize: 14,
                        color: '#fff',
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            opacity: 0.3,
                        },
                    },
                },
                legend: {
                    show: true,
                    top: 'top',
                    left: 'center',
                    itemGap: 50,
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: {
                        color: '#fff',
                        fontSize: 14,
                    },
                },
                tooltip: {
                    trigger: 'axis',
                },
                dataset: {
                    source: [],
                },
                series: [
                    {
                        type: 'line',
                        // name: '居家上门服务',
                        symbolSize: 5,
                        label: {
                            show: true,
                            position: 'top',
                            distance: 8,
                            fontSize: 14,
                            color: '#ff2538',
                            formatter: (params) => {
                                const { value } = params;
                                return value.house;
                            },
                        },
                        itemStyle: {
                            color: '#ff2538',
                        },
                        lineStyle: {
                            color: '#ff2538',
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: 'rgba(255,37,56,0.5)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(255,37,56,0)',
                                    },
                                ],
                                global: false,
                            },
                            shadowBlur: 10,
                            shadowColor: 'rgba(255,37,56,0.8)',
                        },
                        encode: {
                            x: 'month',
                            y: 'house',
                            tooltip: 'house',
                        },
                    },
                    /*{
                      type: 'line',
                      name: '政府购买服务',
                      label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#00afe3',
                        formatter: (params) => {
                          const { value } = params;
                          return numToThousands(value.govern);
                        },
                      },
                      itemStyle: {
                        color: '#00afe3',
                      },
                      lineStyle: {
                        color: '#00afe3',
                      },
                      areaStyle: {
                        color: {
                          type: 'linear',
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [
                            {
                              offset: 0,
                              color: 'rgba(0,175,227,0.5)',
                            },
                            {
                              offset: 1,
                              color: 'rgba(0,175,227,0)',
                            },
                          ],
                          global: false,
                        },
                        shadowBlur: 10,
                        shadowColor: 'rgba(0,175,227,0.8)',
                      },
                      encode: {
                        x: 'month',
                        y: 'govern',
                        tooltip: 'govern',
                      },
                    },*/
                ],
            },
        }
    },
    watch: {},
    mounted() {
        PubSub.subscribe('TZ', (msg, data) => {
            this.lineData = data.value
            this.lineOption.dataset.source = data.value
        })
        PubSub.subscribe('TW', (msg, data) => {
            this.lineData = data.value
            this.lineOption.dataset.source = data.value
        })
        PubSub.subscribe('CQXT', (msg, data) => {
            this.lineData = data.value
            this.lineOption.dataset.source = data.value
        })
        PubSub.subscribe('CHXT', (msg, data) => {
            this.lineData = data.value
            this.lineOption.dataset.source = data.value
        })
        PubSub.subscribe('XYG', (msg, data) => {
            this.lineData = data.value
            this.lineOption.dataset.source = data.value
        })
        PubSub.subscribe('XL', (msg, data) => {
            this.lineData = data.value
            this.lineOption.dataset.source = data.value
        })
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.line-charts {
    width: 100%;
    height: 100%;
}

.cv-chart {
    width: 100%;
}
</style>